module.exports = "https://static.cdns.space/tarot-temp/img/blog1-1.a8ca774e.png";